import './HeaderContextImage.css';
import React from 'react';
import { get } from '../../utils';
import { Image } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import LazyPicture from '../atoms/LazyPicture';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
var HeaderContextImage = function HeaderContextImage(_ref) {
  var fields = _ref.fields;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  if (!fields || !Boolean(get(fields, 'data.contextItem.headerImage'))) {
    console.warn('HeaderContextImage component render skipped.');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[Header Context Image rendering: Please base your item on ImageHeader template or any derived template]");
    }
    return null;
  }
  var renderImage = function renderImage(imageField) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LazyPicture, {
      className: "styled-curved-image"
    }, /*#__PURE__*/React.createElement("source", {
      media: "(min-width: 480px)",
      srcSet: "".concat(imageField.value.src, "&cw=1556&ch=690")
    }), /*#__PURE__*/React.createElement("img", {
      src: "".concat(imageField.value.src, "&cw=1556&ch=690"),
      alt: imageField.value.alt,
      title: imageField.value.alt
    })), pageEditing && /*#__PURE__*/React.createElement(Image, {
      field: imageField
    }));
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    className: "header-media remove-padding-header"
  }, fields.data.contextItem && fields.data.contextItem.headerImage && renderImage(fields.data.contextItem.headerImage.jss));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    className = _ref2.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(className, " ").concat(headerImageStyle)
  }, children);
};
var commonStyles = "c140u1m7";
var ltrStyles = "l1s00t67";
var rtlStyles = "rqujjjv";
export default HeaderContextImage;